import { render, staticRenderFns } from "./demo-note.vue?vue&type=template&id=ce9a91d8&"
import script from "./demo-note.vue?vue&type=script&lang=js&"
export * from "./demo-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports